import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails,
    CognitoUserAttribute, CognitoUserSession, CognitoIdToken, CognitoAccessToken, CognitoRefreshToken
} from 'amazon-cognito-identity-js';
import {Config, CognitoIdentityCredentials} from 'aws-sdk';
import axios from 'axios';

/** @class */
export default class Cognito {
    static install = (Vue, options) => {
        Object.defineProperty(Vue.prototype, '$cognito', {
            get() {
                if (!this.$root._cognito) {
                    this.$root._cognito = new Cognito(options);
                }
                return this.$root._cognito;
            }
        });

        Vue.mixin({
            beforeCreate() {
                if (!this.$root._cognito) {
                    this.$root._cognito = new Cognito(options);
                }
            }
        });
    };

    /**
     * @constructor
     * @param config
     */
    constructor(config) {
        Config.region = config.COGNITO.REGION;
        this.userPool = new CognitoUserPool({
            UserPoolId: config.COGNITO.USERPOOLID,
            ClientId: config.COGNITO.USERPOOLCLIENTID
        });
        this.adminUserPool = new CognitoUserPool({
            UserPoolId: config.COGNITO.ADMIN_USERPOOLID,
            ClientId: config.COGNITO.ADMIN_USERPOOLCLIENTID
        });
        this.adminClientId_ = config.COGNITO.ADMIN_USERPOOLCLIENTID;
        this.oAuthBaseUrl_ = config.COGNITO.OAUTH_BASE_URL;
        return this;
    }

    /**
     * username, passwordでサインアップ
     * username = emailとしてUserAttributeにも登録
     * @param username {String}
     * @param password {String}
     * @param officeId {String}
     * @param rehaplanUserId {String}
     * @returns {Promise<any>}
     */
    signUp(username, password, officeId, rehaplanUserId) {
        const attributeList = [];
        attributeList.push(new CognitoUserAttribute({Name: 'email', Value: username}));
        attributeList.push(new CognitoUserAttribute({Name: 'custom:office_id', Value: officeId}));
        attributeList.push(new CognitoUserAttribute({Name: 'custom:rehaplan_user_id', Value: rehaplanUserId}));
        return new Promise((resolve, reject) => {
            this.userPool.signUp(username, password, attributeList, null, (err, result) => {
                if (err) {
                    reject(err);
                } else {
                    resolve('');
                }
            });
        });
    }

    adminLogin() {
        // window.location.hrefと同じ。
        // Method 呼び出しで実装。
        let authUrl = `${this.oAuthBaseUrl_}/login?response_type=token` +
            `&client_id=${this.adminClientId_}&redirect_uri=${this.getRedirectUri_()}`;
        window.location.assign(
            authUrl
        )
    }


    async adminAuthFlow() {
        let authToken = await this.authTokenForAdmin();
        if(authToken) {
            return;
        }
        await this.adminCallBack(location.hash);
        authToken = await this.authTokenForAdmin();
        if(authToken) {
            return;
        }
        this.adminLogin();
    }


    getRedirectUri_() {
        return `${location.protocol}//${location.host}/admin/sign_up`;
    }

    async adminCallBack(tokenInfo) {
        if(!tokenInfo) {
            return;
        }
        let tokenInfoList = tokenInfo.slice(1).split('&');
        if(tokenInfoList.length < 2) {
            return;
        }
        let idToken = '';
        let accessToken = '';
        tokenInfoList.forEach(function(token) {
            if(token.includes(Cognito.ACCESS_TOKEN_KEY)) {
                accessToken = token.replace(Cognito.ACCESS_TOKEN_KEY, '');
            }
            if(token.includes(Cognito.ID_TOKEN_KEY)) {
                idToken = token.replace(Cognito.ID_TOKEN_KEY, '');

            }
        });
        if(!idToken || !accessToken) {
            return;
        }
        let userInfo = await axios.post(`${this.oAuthBaseUrl_}/oauth2/userInfo`, {}, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Authorization": `Bearer ${accessToken}`
            }
        });
        const userData = {Username: userInfo.data.username, Pool: this.adminUserPool};
        const cognitoUser = new CognitoUser(userData);
        const cognitoSession = new CognitoUserSession({
            IdToken: new CognitoIdToken({IdToken: idToken}),
            AccessToken: new CognitoAccessToken({AccessToken: accessToken}),
            RefreshToken: new CognitoRefreshToken({RefreshToken: ''})
        });
        cognitoUser.setSignInUserSession(cognitoSession);
    }

    /**
     * 確認コードからユーザーを有効化する
     * @param username
     * @param confirmationCode
     * @returns {Promise<any>}
     */
    confirmation(username, confirmationCode) {
        const userData = {Username: username, Pool: this.userPool};
        const cognitoUser = new CognitoUser(userData);
        return new Promise((resolve, reject) => {
            cognitoUser.confirmRegistration(confirmationCode, true, (err, result) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(result);
                }
            });
        });
    }

    /**
     * username, passwordでログイン
     */
    login(username, password) {
        const userData = {Username: username, Pool: this.userPool};
        const cognitoUser = new CognitoUser(userData);
        const authenticationData = {Username: username, Password: password};
        const authenticationDetails = new AuthenticationDetails(authenticationData);
        return new Promise((resolve, reject) => {
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: (result) => {
                    resolve(result);
                },
                onFailure: (err) => {
                    reject(err.code);
                }
            });
        });
    }

    loginBySession(email, idToken, accessToken, refreshToken) {

        const userData = {Username: email, Pool: this.userPool};
        const cognitoUser = new CognitoUser(userData);
        const cognitoSession = new CognitoUserSession({
            IdToken: new CognitoIdToken({IdToken: idToken}),
            AccessToken: new CognitoAccessToken({AccessToken: accessToken}),
            RefreshToken: new CognitoRefreshToken({RefreshToken: refreshToken})
        });
        cognitoUser.setSignInUserSession(cognitoSession);
        return new Promise((resolve) => {
            cognitoUser.refreshSession(cognitoSession.getRefreshToken(),
                (err, newSession) => {
                    if (err) throw err;
                    console.log(newSession);
                    cognitoUser.setSignInUserSession(newSession);
                    resolve('');
                }
            );
        })
    }

    getUserAttributes() {
        let self_ = this;
        return new Promise((resolve) => {
            let user = self_.getCurrentUser();
            if (!user) {
                resolve([]);
            }
            user.getSession((err, session) => {
                user.getUserAttributes((err, result) => {
                    if (err) {
                        console.log(err);
                        resolve([])
                    }
                    resolve(result)
                });
            });
        });
    }

    /**
     * ログアウト
     */
    logout() {
        this.getCurrentUser().signOut();
    }

    /**
     * Login中のUserを返却
     * @returns {CognitoUser}
     */
    getCurrentUser() {
        return this.userPool.getCurrentUser();
    }

    /**
     * Login中のUserを返却
     * @returns {CognitoUser}
     */
    getCurrentAdminUser() {
        return this.adminUserPool.getCurrentUser();
    }



    /**
     * ログインしているユーザーのAuthTokenを取得。
     */
    authToken() {
        const cognitoUser = this.getCurrentUser();
        return new Promise((resolve) => {
            if (cognitoUser === null) {
                resolve(null);
            }
            cognitoUser.getSession((err, session) => {
                if (err) {
                    resolve(null);
                } else {
                    if (!session.isValid()) {
                        resolve(null);
                    } else {
                        resolve(session.getIdToken().getJwtToken());
                    }
                }
            });
        });
    }

    /**
     * ログインしているユーザーのAuthTokenを取得。
     */
    authTokenForAdmin() {
        const cognitoUser = this.getCurrentAdminUser();
        return new Promise((resolve) => {
            if (cognitoUser === null) {
                resolve(null);
            }
            cognitoUser.getSession((err, session) => {
                if (err) {
                    resolve(null);
                } else {
                    if (!session.isValid()) {
                        resolve(null);
                    } else {
                        resolve(session.getIdToken().getJwtToken());
                    }
                }
            });
        });
    }

    static get ERROR_CODE() {
        return {
            NOT_AUTHORIZED: 'NotAuthorizedException',
            NOT_CONFIRMED: 'UserNotConfirmedException'
        };
    }


    static get ACCESS_TOKEN_KEY() {
        return 'access_token='
    }

    static get ID_TOKEN_KEY() {
        return 'id_token='
    }

}



// WEBPACK FOOTER //
// ./src/custom_plugins/auth/cognito.js